module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"A rate tailored to your needs.","payText":"At UniversalPay we adapt all our services to your needs. And the rates, too.","payBtn":"CHECK OUT THE RATES"},"es":{"payTitulo":"Centro de logotipos.","payText":"Descarga la imagen de la marca UniversalPay y muestra a tus clientes que pueden realizar pagos con seguridad y confianza.","payBtn":"CENTRO DE LOGOTIPOS"}}')
  delete Component.options._Ctor
}
